import {
  Button,
  Grid,
  Step,
  StepLabel,
  Stepper,
  IconButton,
  Typography,
  TextField,
  MenuItem,
  Avatar,
} from "@mui/material";

import { BsCheckCircleFill } from "react-icons/bs";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import CourseCard from "../../components/CourseCard.jsx";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  getCoursesList,
  getSingleCourse,
} from "../../services/course.service.js";
import { MdAdd, MdDelete, MdEdit, MdEventSeat } from "react-icons/md";
import Toast from "../../components/Toast.jsx";
import Constants from "../../data/Constants.js";
import Utils from "../../utils/index.js";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  createSchedule,
  getClassList,
  getSingleClass,
} from "../../services/classes.service";
import { getMentorsList } from "../../services/mentor.service";
import EditClassDialog from "components/EditClassDialog.jsx";
import moment from "moment";
import EditSessionDialog from "components/class/EditSessionDialog.jsx";
import { isMobile } from "react-device-detect";
import Lottie from "react-lottie-player";

import successTicketLottie from "data/lotties/success-tick.json";

const steps = [
  "Choose a Course",
  "Choose Class",
  "Assign Mentor",
  "Schedule Time",
];

function CourseClass(props) {
  const navigate = useNavigate();
  const { setProgress, setToast, isRefreshed, runCanfetti } =
    useOutletContext();

  const [courses, setCourses] = useState(false);
  const [classes, setClasses] = useState(false);
  const [curriculum, setCurriculum] = useState(false);
  const [mentors, setMentors] = useState(false);
  const [status, setStatus] = useState({ loading: true, error: false });

  const [activeCourse, setActiveCourse] = useState();
  const [activeClass, setActiveClass] = useState();
  const [step4Data, setStep4Data] = useState({ time: new Date(), gap: 7 });
  const [step3Data, setStep3Data] = useState({ mentors: [] });

  const [classDialogBox, setClassDialogBox] = useState({
    open: false,
    data: null,
  });

  const [sessionDialogBox, setSessionDialogBox] = useState({
    open: false,
    data: null,
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [stepValidated, setStepValidation] = React.useState(false);

  const [skipped, setSkipped] = React.useState(new Set());

  useEffect(() => {
    if (activeStep == 0) {
      if (activeCourse) {
        // set next true
        setStepValidation(true);
      } else {
        setStepValidation(false);
      }
    }

    if (activeStep == 1) {
      if (activeClass) {
        // set next true
        setStepValidation(true);
      } else {
        setStepValidation(false);
      }
    }

    if (activeStep == 3) {
      var isAllScheduled = true;
      for (let tModule of curriculum.modules) {
        if (!isAllScheduled) {
          break;
        }

        for (let topic of tModule.topics) {
          if (topic.type != "Session") {
            continue;
          }

          if (
            activeClass.sessions.findIndex((v) =>
              v._new ? v.topic == topic._id : v.topic._id == topic._id
            ) == -1
          ) {
            isAllScheduled = false;
            break;
          }
        }
      }

      if (isAllScheduled) {
        // set next true
        setStepValidation(true);
      } else {
        setStepValidation(false);
      }
    }

    if (activeStep == 2) {
      console.log(step3Data);
      if (step3Data.mentors.length != 0) {
        // set next true
        setStepValidation(true);
      } else {
        setStepValidation(false);
      }
    }
  }, [activeCourse, activeClass, step3Data, activeStep]);

  useEffect(() => {
    if (activeCourse) {
      loadCurriculum();
      loadClasses();
    }
  }, [activeCourse]);

  const formSubmitHandler = async () => {
    // client validations

    if (!activeClass && step3Data.mentors) {
      setToast({ error: true, message: "Input is Incomplete" });
    }

    activeClass.mentors = [];
    step3Data.mentors.map((mentor) => {
      activeClass.mentors.push(mentor._id);
    });

    const payload = {
      class: activeClass,
    };

    try {
      setProgress(true);

      const res = await createSchedule(payload);

      setProgress(false);

      setToast({
        success: true,
        message: "Class Successfully Scheduled",
      });

      runCanfetti();
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  async function loadCourses() {
    try {
      const filters = {
        type: [
          Constants.Course.Type.LIVE_SINGLE,
          Constants.Course.Type.LIVE_GROUP,
        ].toString(),
      };
      setProgress(true);
      const data = await getCoursesList(filters);
      if (data) {
        setCourses(data);
        setProgress(false);
      } else {
        // error
        setProgress(false);
        setToast({ error: true, message: Constants.Error.FETCH });
      }
    } catch (error) {
      // error
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  }

  async function loadCurriculum() {
    try {
      setProgress(true);
      const data = await getSingleCourse(activeCourse._id);
      if (data) {
        setCurriculum(data.courseDetails.curriculum);
        setProgress(false);
      } else {
        // error
        setProgress(false);
        setToast({ error: true, message: Constants.Error.FETCH });
      }
    } catch (error) {
      // error
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  }

  async function loadSingleClass(classId, localCourseClass) {
    try {
      setProgress(true);
      const data = await getSingleClass(classId);
      if (data) {
        console.log(data);
        data.totalSeats = localCourseClass.totalSeats; // get updated total seats to update
        console.log(data.totalSeats, localCourseClass);
        setActiveClass(data);
        setProgress(false);
      } else {
        // error
        setProgress(false);
        setToast({ error: true, message: Constants.Error.FETCH });
      }
    } catch (error) {
      // error
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  }

  const loadClasses = async () => {
    if (!activeCourse || classes) {
      return;
    }
    try {
      const filters = {
        course: activeCourse._id,
      };
      const data = await getClassList(filters);
      if (data) {
        setClasses(data);
        setStatus({
          loading: false,
          error: false,
        });
      } else {
        // error
        setStatus({
          loading: false,
          error: true,
          errorMessage: Constants.Error.UNKNOWN,
        });
      }
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        errorMessage: Utils.CustomErrorMessage(error),
      });
    }
  };

  const loadMentors = async () => {
    try {
      const data = await getMentorsList();
      if (data) {
        setMentors(data);
        setStatus({
          loading: false,
          error: false,
        });
      } else {
        // error
        setStatus({
          loading: false,
          error: true,
          errorMessage: Constants.Error.UNKNOWN,
        });
      }
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        errorMessage: Utils.CustomErrorMessage(error),
      });
    }
  };

  useEffect(() => {
    if (activeStep == 0) {
      // STEP - 1 API
      loadCourses();
    } else if (activeStep == 1) {
      // STEP - 1 API
    } else if (activeStep == 2) {
      loadMentors();
    } else if (activeStep == 4) {
      formSubmitHandler();
    }
  }, [activeStep, isRefreshed]);

  const isStepOptional = (step) => {
    return false;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    setStepValidation(false); // disable next button

    let newSkipped = skipped;

    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const views = [
    <Grid container>
      <Toast
        error={status.error}
        message={status.errorMessage}
        onClose={() => {
          setStatus({ ...status, error: false });
        }}
      />

      <h1 className="font-bold  w-full py-2 mt-4">Choose Course:</h1>

      {courses &&
        courses.map((course, index) => {
          var cls = "";
          if (activeCourse) {
            if (activeCourse._id == course._id) {
              cls = cls + "outline";
            }
          }
          return (
            <CourseCard
              key={index}
              course={course}
              hideActionBar={true}
              className={
                "m-2 cursor-pointer hover:scale-105 transition-all duration-1000 ease-in-out outline-primary " +
                cls
              }
              onClick={() => {
                console.log("Clicked ", course._id);
                setActiveCourse(course);
              }}
            />
          );
        })}
    </Grid>,

    <React.Fragment>
      <Grid container className="my-2">
        <h1 className="font-bold w-full py-2">Choose Class:</h1>
        {classes &&
          classes.map((courseClass) => {
            var cn = "";
            if (activeClass) {
              if (activeClass._id == courseClass._id) {
                cn += "outline";
              }
            }
            return (
              <div
                className={
                  "bg-gray-200 rounded-lg text-center m-2 cursor-pointer shadow-xl w-36 hover:scale-105 outline-primary " +
                  cn
                }
                onClick={() => {
                  if (courseClass._new) {
                    setActiveClass(courseClass);
                  } else {
                    loadSingleClass(courseClass._id, courseClass);
                  }
                  setStep3Data({ mentors: courseClass.mentors });
                }}
              >
                <div className="font-bold my-5 p-4">
                  {courseClass._new
                    ? "New  Batch"
                    : "Batch " + courseClass.batchNumber}
                </div>

                <Button
                  fullWidth
                  onClick={() => {
                    navigate("/dashboard/classes/students/" + courseClass._id);
                  }}
                  disabled={courseClass._new}
                >
                  <b>View</b>
                </Button>

                <Button
                  fullWidth
                  onClick={(e) => {
                    setClassDialogBox({
                      ...classDialogBox,
                      open: true,
                      data: courseClass,
                    });
                  }}
                >
                  <b>Edit</b>
                  {/* <MdEdit className="text-primary text-xl" /> */}
                </Button>
                <div className="bg-primary rounded text-white p-2 flex items-center justify-center gap-2">
                  <MdEventSeat />
                  <span className="">
                    {courseClass.bookedSeats + "/" + courseClass.totalSeats}
                  </span>
                </div>
              </div>
            );
          })}

        <div
          className="rounded-lg text-center m-2 w-36 cursor-pointer shadow-xl flex items-center justify-center bg-primary hover:bg-primaryDark active:bg-primaryDark"
          onClick={(e) => {
            setClassDialogBox({
              ...classDialogBox,
              open: true,
              data: null,
            });
          }}
        >
          <div className="text-white rounded p-4 text-3xl  w-100">
            <MdAdd />
          </div>
        </div>
      </Grid>
      {classDialogBox.open && (
        <EditClassDialog
          data={classDialogBox.data}
          course={activeCourse}
          onClose={() => {
            setClassDialogBox({ ...classDialogBox, open: false });
          }}
          onChange={(nClass) => {
            if (classDialogBox.data) {
              const tmp = [...classes];
              const index = tmp.findIndex((val) => {
                return val._id == nClass._id;
              });
              tmp[index] = nClass;
              setClasses(tmp);

              // update the total seats in active class also if selected

              if (activeClass) {
                if (activeClass._id == nClass._id) {
                  setActiveClass({
                    ...activeClass,
                    totalSeats: nClass.totalSeats,
                  });
                }
              }
            } else {
              //  new Class
              const tmp = [...classes];
              tmp.push(nClass);
              setClasses(tmp);

              setActiveClass(nClass);
            }
          }}
        />
      )}
    </React.Fragment>,
    <React.Fragment>
      <Grid>
        <h1 className="font-bold  w-full py-2">Choose New Mentor:</h1>

        <TextField
          label="Choose Mentor"
          variant="filled"
          size="small"
          fullWidth
          value={"none"}
          onChange={(e) => {
            if (
              step3Data.mentors.findIndex((m) => {
                return m._id == e.target.value._id;
              }) == -1
            ) {
              var tmp = [...step3Data.mentors];
              tmp.push(e.target.value);
              setStep3Data({ ...step3Data, mentors: tmp });
            }
          }}
          select
          required
        >
          <MenuItem key={-1} value="none">
            Not Set
          </MenuItem>
          {mentors &&
            mentors.map((mentor, index) => {
              return (
                <MenuItem key={index} value={mentor}>
                  {mentor.firstname +
                    " " +
                    mentor.lastname +
                    " (" +
                    mentor._id.slice(0) +
                    ")"}
                </MenuItem>
              );
            })}
        </TextField>

        <h1 className="font-bold  w-full py-2">Assigned Mentors:</h1>

        <div>
          {step3Data.mentors &&
            step3Data.mentors.map((mentor) => {
              return (
                <div className="bg-secondary p-2 my-4 rounded-md flex gap-2 items-center">
                  <Avatar src={mentor.picture} size="small" className="m-2" />
                  <div className="flex-grow">
                    {mentor.firstname +
                      " " +
                      mentor.lastname +
                      " (" +
                      mentor._id +
                      ")"}
                  </div>

                  <IconButton>
                    <MdDelete
                      className="cursor-pointer"
                      size={24}
                      onClick={() => {
                        const index = step3Data.mentors.findIndex((m) => {
                          return m._id == mentor._id;
                        });

                        if (index != -1) {
                          var tmp = [...step3Data.mentors];
                          tmp.splice(index, 1);
                          setStep3Data({ ...step3Data, mentors: tmp });
                        }
                      }}
                    />
                  </IconButton>
                </div>
              );
            })}
        </div>
      </Grid>
    </React.Fragment>,
    <React.Fragment>
      <div className="my-4">
        <h1 className="font-bold  w-full py-2">Choose Time:</h1>

        <div className="my-4">
          {activeClass &&
            curriculum &&
            curriculum.modules.map((tModule, moduleIndex) => {
              return tModule.topics.map((topic, topicIndex) => {
                if (topic.type != "Session") {
                  return;
                }

                console.log(activeClass.sessions);

                const session = activeClass.sessions.find((session) => {
                  return session._new
                    ? session.topic == topic._id
                    : session.topic._id == topic._id; // becuase from server topic is populated
                });

                return (
                  <div className="p-4 m-2 rounded-md shadow-sm bg-secondary flex gap-2 items-center flex-col md:flex-row">
                    <div className="flex-grow flex gap-2">
                      <div className="font-bold">{topic.name}</div>
                      <span className="text-sm font-normal">
                        ({topic.type})
                      </span>
                      <div className="text-sm">
                        &bull; {topic.minutes} minutes
                      </div>
                    </div>

                    <div className="flex gap-5 text-sm items-center">
                      <div>
                        {session ? (
                          <div className="flex items-center gap-2">
                            {moment(session.time).format(
                              "dddd, MMMM Do YYYY, h:mm a"
                            )}
                            <BsCheckCircleFill />
                          </div>
                        ) : (
                          "Not Scheduled"
                        )}
                      </div>

                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => {
                          if (session) {
                            setSessionDialogBox({ open: true, data: session });
                          } else {
                            const newSession = {
                              topic: topic._id,
                              duration: topic.minutes ?? 30,
                              courseClass: activeClass._id,
                              time: "",
                              _new: true,
                            };

                            setSessionDialogBox({
                              open: true,
                              data: newSession,
                            });
                          }
                        }}
                      >
                        Change
                      </Button>
                    </div>
                  </div>
                );
              });
            })}

          {sessionDialogBox.open && (
            <EditSessionDialog
              session={sessionDialogBox.data}
              onClose={() => {
                setSessionDialogBox({
                  ...sessionDialogBox,
                  open: false,
                });
              }}
              onChange={(session) => {
                const temp = [...activeClass.sessions];
                if (session._new) {
                  const index = temp.findIndex(
                    (val) => val.topic == session.topi
                  );
                  if (index == -1) {
                    temp.push(session);
                  } else {
                    temp[index] = session;
                  }
                } else {
                  const index = temp.findIndex((v) => v._id == session._id);
                  temp[index] = session;
                }

                setActiveClass({ ...activeClass, sessions: temp });
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>,
  ];

  return (
    <div>
      <Stepper
        activeStep={activeStep}
        orientation={isMobile ? "vertical" : "horizontal"}
        className="my-2"
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
              <Typography variant="caption">Optional</Typography>
            );
          }

          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
              {index == 0 && (
                <div className="text-sm">
                  {activeCourse && activeCourse.name}
                </div>
              )}

              {index == 1 && (
                <div className="text-sm">
                  {activeClass &&
                    (activeClass.batchNumber
                      ? "Batch " + activeClass.batchNumber
                      : "New Batch")}
                </div>
              )}
            </Step>
          );
        })}
      </Stepper>

      {activeStep === steps.length ? (
        <React.Fragment>
          <div className="text-lg font-bold my-8 text-center">
            <Lottie
              animationData={successTicketLottie}
              play
              loop={false}
              style={{ width: 150, height: 150 }}
              className="m-auto"
            />
            Class Scheduled Successfully !!
          </div>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleReset}>Ok</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {/* STEP - 1 */}
          <div>{views[activeStep]}</div>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            {isStepOptional(activeStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )}

            <Button onClick={handleNext} disabled={!stepValidated}>
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          </Box>
        </React.Fragment>
      )}
    </div>
  );
}

export default CourseClass;
